import { Fade } from '@mui/material';
import { Components, Theme } from '@mui/material/styles';

export const MuiPopover: Components<Theme>['MuiPopover'] = {
  defaultProps: {
    slots: {
      transition: Fade,
    },
  },
};
